import styled from 'styled-components'

import Box from '../../box'

export default styled(Box).attrs({ jc: 'fs', ai: 'fs', fd: 'c' })`
  min-width: 0;
`
